<template>
	<div class="sidebar-companion__wrapper">
		<div class="sidebar-companion__content-wrapper">
			<div
				class="sidebar-companion__content"
				:style="`transform: translate(${translateStyle}) scale(${scaleValue})`"
			>
				<div
					class="sidebar-companion__bg"
					:style="bgTransformStyle"
				></div>
				<div style="display: flex; flex-direction: column">
					<div
						class="sidebar-companion__image"
						:style="memojiTransformStyle"
					>
						<img
							:class="{
								'hide-default-content':
									showRouteProps,
							}"
							class="sidebar-companion__default-content"
							:src="defaultProps.memoji"
						/>
						<transition name="fade">
							<img
								v-if="showRouteProps"
								class="sidebar-companion__route-content"
								:src="routeProps.memoji"
							/>
						</transition>
					</div>
					<div
						class="sidebar-companion__title"
						:style="textTransformStyle"
					>
						<h3
							:class="{
								'hide-default-content':
									showRouteProps,
							}"
							class="sidebar-companion__default-content"
						>
							{{ defaultProps.corner_text }}
						</h3>
						<transition name="fade">
							<h3
								v-if="showRouteProps"
								class="sidebar-companion__route-content"
							>
								{{
									routeProps.corner_text
								}}
							</h3>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	props: [
		"defaultProps",
		"routeProps",
		"isHeadingVisible",
		"toFinalPosition",
	],
	computed: {
		showRouteProps() {
			if (this.isMobile) return this.toFinalPosition === 1;
			return !this.isHeadingVisible;
		},
		decimalPercentage() {
			return (this.toFinalPosition - 1) * -1;
		},

		isMobile() {
			return window.outerWidth <= 550;
		},
		passedPercentage() {
			return this.toFinalPosition * 100;
		},

		//desktopTransformCalculation
		scaleValue() {
			if (this.isMobile) return;
			let minValue = 0.85;
			if (window.outerWidth < 1000) minValue = 0.8;
			else if (window.outerWidth < 800) minValue = 0.75;

			let maxValue = 100 - minValue * 100;

			let scaleResult =
				(this.decimalPercentage * 70 * maxValue) / 100;
			// turn it to decimal as used by transform scale
			// and shift the value to account for real range
			scaleResult = scaleResult / 100 + minValue;
			if (scaleResult < 0) scaleResult = 0;
			return scaleResult;
		},
		yTranslateValue() {
			let yTranslateValue = 100 - this.decimalPercentage * 100;
			return yTranslateValue > 10 ? 10 : yTranslateValue;
		},
		translateStyle() {
			let translateValue = this.yTranslateValue;
			return `-${translateValue}%, -${
				translateValue - translateValue / 2
			}%`;
		},

		// mobile transform calculation
		mobileBGTranslateY() {
			let min = -57;
			let max = -65;
			return this.percentageToValueInRange(min, max);
		},
		mobileBGTranslateX() {
			let min = 3;
			let max = 20;
			return this.percentageToValueInRange(min, max);
		},
		mobileBGRotate() {
			let min = 45;
			let max = 0;
			return this.percentageToValueInRange(min, max);
		},
		mobileTextX() {
			let routeMaxValue = this.$route.meta.designatedTextX;
			let min = 0;
			let max = routeMaxValue ? routeMaxValue : 15;
			return this.percentageToValueInRange(min, max);
		},
		mobileTextY() {
			let min = 0;
			let max = -110;
			return this.percentageToValueInRange(min, max);
		},
		mobileTextScale() {
			let min = 1;
			let max = 0.9;
			return this.percentageToValueInRange(min, max);
		},
		mobileMemojiX() {
			let min = 0;
			let max = -170;
			return this.percentageToValueInRange(min, max);
		},
		mobileMemojiY() {
			let min = 0;
			let max = -25;
			return this.percentageToValueInRange(min, max);
		},
		mobileMemojiScale() {
			let min = 1;
			let max = 0.7;
			let result = this.percentageToValueInRange(min, max);
			return result;
		},
		textTransformStyle() {
			if (!this.isMobile) return "";
			let {
				mobileTextX: x,
				mobileTextY: y,
				mobileTextScale: s,
			} = this;
			return `transform: translate(${x}%, ${y}%) scale(${s})`;
		},
		bgTransformStyle() {
			if (!this.isMobile) return "";
			let {
				mobileBGTranslateX: x,
				mobileBGTranslateY: y,
				mobileBGRotate: r,
			} = this;
			return `transform: translate(${x}%, ${y}%) rotate(${r}deg)`;
		},
		memojiTransformStyle() {
			if (!this.isMobile) return "";
			let {
				mobileMemojiX: x,
				mobileMemojiY: y,
				mobileMemojiScale: s,
			} = this;
			return `transform: translate(${x}%, ${y}%) scale(${s})`;
			// translate(-100%,-20%) scale(.8)
		},
	},
	methods: {
		percentageToValueInRange(minValue, maxValue) {
			let passedPercentage = this.passedPercentage;
			let initialMinValue = minValue;

			let sum = maxValue - minValue; //15
			let result = (passedPercentage / 100) * sum; //4.5
			return (result += initialMinValue);
		},
	},
};
</script>
<style lang="scss" scoped>
.sidebar-companion {
	&__bg {
		width: 200%;
		height: 100%;
		border-radius: 50vw;
		border-bottom-left-radius: 0px;
		border-top-left-radius: 0px;
		position: absolute;
		top: 0;
		right: 0;
		z-index: 0;
		transform: rotate(45deg) translate(-6%, -35%);
		background-color: var(--theme);

		@media screen and (max-width: 550px) {
			transform: rotate(45deg) translate(5, -48);
			will-change: transform;
		}
	}

	&__wrapper {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		display: flex;
		z-index: 10;
		pointer-events: none;
	}

	&__content-wrapper {
		margin: 0 auto;
		background-color: transparent;
		width: 100%;
		max-width: 1200px;
	}

	&__content {
		max-width: calc(100% / 3);
		display: flex;
		position: relative;
		padding: 50px;
		transform-origin: top left;
		transition: transform 0.1s;
		will-change: transform;

		> div {
			z-index: 1;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
		}

		img {
			align-self: center;
			width: 10rem;
			max-width: 144px;

			@media screen and (min-width: 1200px) {
				width: 112px;
			}
		}

		h3 {
			white-space: pre;
			font-size: 2.5rem;

			@media screen and (min-width: 1200px) {
				font-size: 28px;
			}
		}

		@media screen and (max-width: 550px) {
			padding: 20px;
			max-width: unset;

			img {
				width: 20rem;
			}

			h3 {
				font-size: 7rem;
			}
		}
	}

	&__image,
	&__title {
		position: relative;
		text-align: center;
	}

	&__default-content {
		transition: opacity 0.5s;
		position: relative;
		opacity: 1;
		will-change: opacity;

		&.hide-default-content {
			opacity: 0;
		}
	}

	&__title {
		display: flex;
		justify-content: center;
	}

	&__route-content {
		position: absolute;
		top: 0;
		left: auto;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
		@media screen and (max-width: 500px) {
			left: 0;
		}
	}
}
</style>
